import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { authHeaders } from "../pages/AdminPage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SettingsTab = () => {
  const [hero, setHero] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then((r) => setHero(r.data.hero_image_url || ""))
      .catch(() => toast.error("Could not load settings"))
      .finally(() => setLoading(false));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${API}/admin/settings`, { hero_image_url: hero.trim() }, { headers: authHeaders() });
      toast.success("Storefront updated — refresh the store to see it");
    } catch {
      toast.error("Save failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading)
    return (
      <p className="py-20 text-center font-serif-d italic text-xl text-[#8A818F]">Loading…</p>
    );

  return (
    <form onSubmit={save} className="max-w-xl" data-testid="settings-form">
      <h3 className="font-serif-d text-2xl text-[#2D1B36] mb-2">Hero photograph</h3>
      <p className="text-sm text-[#514357] leading-relaxed mb-8">
        Paste a link to a real photo of your shop's shelves and it becomes the big
        welcome image on the homepage. Leave empty to use the default lace photo.
        (Tip: send us the photo in chat and we'll host it for you.)
      </p>
      <label className="font-accent text-[10px] tracking-[0.3em] uppercase text-[#8A818F]">
        Image URL
      </label>
      <input
        type="url"
        value={hero}
        onChange={(e) => setHero(e.target.value)}
        placeholder="https://…"
        data-testid="settings-hero-input"
        className="w-full bg-transparent border-b border-[#E8E4DF] focus:border-[#C5A059] px-0 py-3 text-[#2D1B36] placeholder-[#8A818F] transition-colors duration-300"
      />
      {hero && (
        <img
          src={hero}
          alt="Hero preview"
          data-testid="settings-hero-preview"
          className="mt-6 w-full aspect-video object-cover border border-[#E8E4DF]"
          onError={(e) => (e.target.style.display = "none")}
          onLoad={(e) => (e.target.style.display = "block")}
        />
      )}
      <button
        type="submit"
        disabled={saving}
        data-testid="settings-save-button"
        className="mt-8 flex items-center gap-2 bg-[#4A2B58] text-[#FBF9F6] font-accent text-[11px] tracking-[0.25em] uppercase px-8 py-4 hover:bg-[#2D1B36] transition-colors duration-300 disabled:opacity-60"
      >
        <Save size={13} /> {saving ? "Saving…" : "Save Storefront"}
      </button>
    </form>
  );
};
